import { Component, OnInit } from '@angular/core';
import { Router,  NavigationExtras, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  financialTrYN: string;

  constructor( private router:Router) { 
    this.financialTrYN=sessionStorage.getItem('financialTrYN');
    console.log('financialTrYN:-------------'+this.financialTrYN);
  }

  ngOnInit() {
  }
   
	addPayee()
   {
	  this.router.navigate(['/add-payee'])
        .then(() => {
           this.router.navigate(['/add-payee']); 
     });

   }
   
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/Components/sidebar/sidebar.component.ts